//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ProfileClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export function profileUpdateSettingsUrl(): string {
  let url_ = getBaseUrl() + "/api/account/my-profile/settings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function profileUpdateSettingsMutationKey(): MutationKey {
  return trimArrayEnd([
      'ProfileClient',
      'profileUpdateSettings',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useProfileUpdateSettingsMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.UpdateProfileSettingsDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateProfileSettingsDto, TContext> {
  const key = profileUpdateSettingsMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.UpdateProfileSettingsDto) => Client.profileUpdateSettings(body),
    mutationKey: key,
  });
}
  
export function profileGetUrl(): string {
  let url_ = getBaseUrl() + "/api/account/my-profile";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let profileGetDefaultOptions: Omit<UseQueryOptions<Types.ProfileDto, unknown, Types.ProfileDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ProfileDto, unknown, Types.ProfileDto>, 'queryFn'>> = {
};
export function getProfileGetDefaultOptions() {
  return profileGetDefaultOptions;
};
export function setProfileGetDefaultOptions(options: typeof profileGetDefaultOptions) {
  profileGetDefaultOptions = options;
}

export function profileGetQueryKey(): QueryKey;
export function profileGetQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'ProfileClient',
      'profileGet',
    ]);
}
export function __profileGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.profileGet(
axiosConfig    );
}

/**
 * @return OK
 */
export function useProfileGetQuery<TSelectData = Types.ProfileDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.ProfileDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useProfileGetQuery<TSelectData = Types.ProfileDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ProfileDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ProfileDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __profileGet(context, axiosConfig) : __profileGet,
    queryKey: profileGetQueryKey(),
    ...profileGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.ProfileDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setProfileGetData(queryClient: QueryClient, updater: (data: Types.ProfileDto | undefined) => Types.ProfileDto, ) {
  queryClient.setQueryData(profileGetQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setProfileGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ProfileDto | undefined) => Types.ProfileDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function profileUpdateUrl(): string {
  let url_ = getBaseUrl() + "/api/account/my-profile";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function profileUpdateMutationKey(): MutationKey {
  return trimArrayEnd([
      'ProfileClient',
      'profileUpdate',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useProfileUpdateMutation<TContext>(options?: Omit<UseMutationOptions<Types.ProfileDto, unknown, Types.UpdateProfileDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ProfileDto, unknown, Types.UpdateProfileDto, TContext> {
  const key = profileUpdateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.UpdateProfileDto) => Client.profileUpdate(body),
    mutationKey: key,
  });
}
  
export function profileChangePasswordUrl(): string {
  let url_ = getBaseUrl() + "/api/account/my-profile/change-password";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function profileChangePasswordMutationKey(): MutationKey {
  return trimArrayEnd([
      'ProfileClient',
      'profileChangePassword',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useProfileChangePasswordMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.ChangePasswordInput, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ChangePasswordInput, TContext> {
  const key = profileChangePasswordMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.ChangePasswordInput) => Client.profileChangePassword(body),
    mutationKey: key,
  });
}